
<div class="recompensas-card" v-if="storeVersioned">
    <a class="recompensas-card__img" :href="itemUrl">
        <img v-if="item.promotion_image" width="400" height="300"
             :src="item.promotion_image.public_path + '?size=list'"
             class="recompensas-card__img-in"
             :alt="item.promotion_image.alt"/>
    </a>

    <div class="recompensas-card__right">
        <div class="d-flex flex-column h-100 justify-content-center align-items-center px-3">
            <div class="recompensas-card__brand mt-3 mt-sm-2">
                <img v-if="storeVersioned && storeVersioned.thumbnail" width="150" height="150"
                     :src="storeVersioned.thumbnail.public_path + '?size=list'"
                     class="img-brand"
                     :alt="storeVersioned.thumbnail.alt"/>
            </div>
            <span class="recompensas-card__discount mt-1 mb-2">
                {{item.discount}}
            </span>
        </div>
        <a class="btn btn-primary px-4 w-100 d-flex flex-nowrap align-items-center justify-content-center" :href="itemUrl">
            <span class="pe-3" v-html="configTexts.detailedBtn"></span>
            <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18">
        </a>
    </div>
</div>
